import { useState, useEffect } from "react";
import { IconButton } from "@chakra-ui/react";
import { FiMaximize, FiMinimize } from "react-icons/fi";

const FullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  return (
    <IconButton
      icon={isFullscreen ? <FiMinimize /> : <FiMaximize />}
      aria-label={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
      onClick={toggleFullscreen}
      variant="ghost"
      size="sm"
    />
  );
};

export default FullscreenToggle;
